import Paper from '@mui/material/Paper'
import { DataGridPremium } from '@mui/x-data-grid-premium/DataGridPremium'
import { FC } from 'react'
import { DataLogger, DataLoggerReadingUpload } from 'src/api'
import { TableToolbar } from 'src/components/ui'
import { DataLoggerReadingUploadsGridColumns } from './dataLoggerColumns'

interface Props {
  dataLogger: DataLogger
}

const columns = [
  DataLoggerReadingUploadsGridColumns.FileName,
  DataLoggerReadingUploadsGridColumns.UploadDate,
  DataLoggerReadingUploadsGridColumns.DateFrom,
  DataLoggerReadingUploadsGridColumns.DateTo,
  DataLoggerReadingUploadsGridColumns.ReadingsCount,
  DataLoggerReadingUploadsGridColumns.Status,
  DataLoggerReadingUploadsGridColumns.MatchReadingsToTimeInterval,
  DataLoggerReadingUploadsGridColumns.ExpectedIntervalInHours,
  DataLoggerReadingUploadsGridColumns.ActualIntervalInHours,
  DataLoggerReadingUploadsGridColumns.WrongIntervalAt,
  DataLoggerReadingUploadsGridColumns.FileNameRawFile,
]

export const DataLoggerReadingUploads: FC<Props> = ({ dataLogger }) => {
  const uploads = dataLogger?.readingsUploads || []
  const exportedFileName = `${document.title}_readings_uploads`

  return (
    <Paper sx={{ flexGrow: 1, minHeight: '200px', width: "100%" }}>
      <DataGridPremium<DataLoggerReadingUpload>
        autoHeight={true}
        disableRowSelectionOnClick
        rows={uploads}
        columns={columns}
        rowThreshold={2}
        columnThreshold={2}
        localeText={{
          columnMenuSortAsc: "Sort A-Z",
          columnMenuSortDesc: "Sort Z-A",
        }}
        slots={{
          toolbar: () => <TableToolbar exportedFileName={exportedFileName} />
        }}
        sx={(theme) => ({
          border: "none",
          "& .MuiDataGrid-columnHeaderTitleContainerContent": {
            paddingLeft: "5px",
            overflow: "visible",
          },
          "& .MuiDataGrid-columnHeaderTitle": {
            whiteSpace: "normal",
            lineHeight: 1,
            fontSize: "13px",
            fontWeight: 400,
            color: "rgba(0, 0, 0, 0.6)",
            overflow: "visible",
          },
        })}
      />
    </Paper>
  )
}
